import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { usePageContext } from '../../hooks/PageContext';

export const BlogPagination: React.FC = () => {
  const { actions } = usePageContext();
  const {
    notes,
    loading,
    paginationMode,
    loadedCount,
    totalNotesCount,
    handleShowMore,
    totalPages,
    currentPage,
    handlePageClick,
  } = actions;

  if (notes.length === 0 || loading) return null;

  return (
    <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {paginationMode === 'loadMore' && loadedCount < totalNotesCount && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <PrimaryButton
            text="Показать ещё"
            onClick={handleShowMore}
            style={{ width: 'fit-content' }}
          />
        </div>
      )}

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', flexWrap: 'wrap' }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => handlePageClick(page)}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '4px',
                border: '1px solid #ddd',
                background: currentPage === page ? '#0078d4' : '#fff',
                color: currentPage === page ? '#fff' : '#000',
                cursor: 'pointer',
                fontWeight: currentPage === page ? 'bold' : 'normal',
              }}
            >
              {page}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};